var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasStatus)?_c('span',{staticClass:"status",class:_vm.classStatus},[_c('span',[_vm._v(_vm._s(_vm.$t(("events.states." + _vm.status))))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }